<script>
  import { createEventDispatcher } from 'svelte';
  import { sumBy, map, orderBy } from 'lodash-es';

  const dispatch = createEventDispatcher();

  import Page from './Page.svelte';
  import Words from './Words.svelte';

  export let id = '';
  export let name = '';
  export let date = '';
  export let pages = [];
  export let words = [];
  export let sorting = 1;

  let hoveredWord = undefined;
  let hoveredPage = undefined;

  $: sortedPages =
    sorting == 1
      ? orderBy(pages, ['infected', 'page'], ['desc', 'asc'])
      : orderBy(pages, 'page', 'asc');

  $: dimmedPages = map(sortedPages, d => {
    let isDimmed = false;
    if (hoveredWord !== undefined) {
      isDimmed = d.words[hoveredWord] === undefined;
    }
    return {
      ...d,
      isDimmed,
    };
  });

  $: highlightedWords = map(words, d => ({
    ...d,
    value:
      hoveredPage !== undefined && hoveredPage.words[d.word]
        ? hoveredPage.words[d.word]
        : d.value,
    isHighlighted: hoveredPage !== undefined && hoveredPage.words[d.word],
  }));

  $: numInfectedPage = sumBy(pages, 'infected');
</script>

<style type="text/scss">
  @import './styles/theme.scss';
  .issue {
    @include fluid-space(margin-bottom, $sp-medium);
  }
  .issue__header {
    @include fluid-space(padding-top padding-bottom, $sp-xxsmall);
    color: #333;
    font-family: $ff-serif;
    font-weight: $fw-bold;
    @include fluid-font-size($fs-semi-medium);
  }
  .issue__header-date {
    @include fluid-font-size($fs-base);
    font-weight: normal;
    font-family: $ff-sans;
    color: $c-gray-2;
  }
  .issue__pages {
    @include fluid-space(margin-top, $sp-xxsmall);
    display: flex;
    flex-wrap: wrap;
  }

  .issue__page {
    transition: all 0.5s;
  }
  .issue__page.is-dimed {
    opacity: 0.2;
    pointer-events: none;
  }
</style>

<div class="issue">
  <div class="issue__header">
    {name}
    {#if date !== ''}
      <span class="issue__header-date">({date})</span>
    {/if}
  </div>

  <div class="issue__words">
    <Words
      items={highlightedWords}
      on:mouseover={d => (hoveredWord = d.detail.id)}
      on:mouseout={d => (hoveredWord = undefined)} />
  </div>

  <div class="issue__pages">
    {#each dimmedPages as page (page.page)}
      <div class="issue__page" class:is-dimed={page.isDimmed}>
        <Page
          items={page.items}
          isInfected={page.infected > 0}
          on:mouseover={() => {
            hoveredPage = page;
            dispatch('mouseover', { issue: id, page: page.page });
          }}
          on:mouseout={() => {
            hoveredPage = undefined;
            dispatch('mouseout');
          }} />
      </div>
    {/each}
  </div>

</div>
